const React = require("react");
const {LINK_FIAT} = require("../../../../../constants/links");
const {Link} = require("../../../../../router");
const AppIcon = require("../../../../icons/Lunu");

module.exports = () => (
  <div className="h140 h80@m layoutRow fhaS fvaC">
    <Link
      className="layoutRow fhaS fvaC tdN olN dn o70:h rlv"
      href={LINK_FIAT}
    >
      <AppIcon className="w128 mr20 rlv cF c0@m"/>
      <div className="rlv">
        <div className="abs svl layoutRow fhaC fvaC">
          <div
            className="cA3A7AC fw3 f16 lh30 lts0em c0@m"
          >Admin</div>
        </div>
      </div>
    </Link>
  </div>
);